import { request } from './http'
import type { NovelImportPreview } from '@/types/nf'

export interface NovelImportPreviewInput {
  text: string
  format?: 'fdx' | 'fountain'
  custom_regex?: string
  allow_markdown_heading?: boolean
}

export interface NovelImportConfirmInput extends NovelImportPreviewInput {
  title: string
  genre?: string
  content_language?: string
}

export interface NovelImportConfirmResponse {
  project_id: string
  chapter_count: number
}

export const novelImportApi = {
  preview: (body: NovelImportPreviewInput): Promise<NovelImportPreview> =>
    request<NovelImportPreview>('/v1/novel-import/preview', { method: 'POST', body }),

  confirm: (body: NovelImportConfirmInput): Promise<NovelImportConfirmResponse> =>
    request<NovelImportConfirmResponse>('/v1/novel-import/confirm', { method: 'POST', body }),
}
